import * as React from "react";
import styled from "styled-components";
import { navTo } from "@origin-digital/event-dispatcher";
import { Logo } from "../Svg/Logo";
import { SmallLogoLink } from "./Navigation";

const Container = styled.div`
  display: flex;
  border-bottom: 1px solid ${(p) => p.theme.colors.grey200};
  background-color: ${(p) => p.theme.colors.white};
`;

const ScopedAuthLogo = styled(SmallLogoLink)`
  border-right: none;
`;

export const NoNavigationHeader = () => (
  <Container data-id="no-nav-header">
    <ScopedAuthLogo
      data-id="no-nav-logolink"
      href="#"
      onClick={() => navTo.home()}
    >
      <Logo id="no-nav-logo" />
    </ScopedAuthLogo>
  </Container>
);
